module.exports = __webpack_public_path__ + "img/displacementHor.c157d0b6.svg";